import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchFacialPlasticSurgeryBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-facial-plastic-surgeries?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFacialPlasticSurgery = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-facial-plastic-surgery-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFacialPlasticSurgeonsBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-facial-plastic-surgeons?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFacialPlasticSurgeons = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-facial-plastic-surgeons-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchRhinoplastyBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-rhinoplasties?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchRhinoplasty = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-rhinoplasty-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchLowerBlepharoplastyBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-lower-blepharoplasties?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchLowerBlepharoplasty = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-lower-blepharoplasty-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchUpperBlepharoplastyBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-upper-blepharoplasties?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchUpperBlepharoplasty = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-upper-blepharoplasty-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFaceLiftBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-face-lifts?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFaceLift = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-face-lift-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchForeHeadLiftBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-fore-head-lifts?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchForeHeadLift = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-fore-head-lift-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchMentoplastyBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-mentoplasties?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchMentoplasty = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-mentoplasty-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchOtoplastyBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-otoplasties?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchOtoplasty = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-otoplasty-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchScarRevisionBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-scar-revisions?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchScarRevision = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-scar-revision-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchSkinCancerBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-skin-cancers?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchSkinCancer = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-skin-cancer-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchSkinPeelsBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-skin-peels?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchSkinPeels = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-skin-peels-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchBotulinumToxinBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-botulinum-toxins?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchBotulinumToxin = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-botulinum-toxin-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFatGraftingBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-fat-graftings?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchFatGrafting = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-fat-grafting-descriptions?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchConsentLetters = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-surgical-domains-consent-letters?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchSurgicalSubHeading = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/sub-headings?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchContentsBySubHeading = async (subHeadingName: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/contents?populate=*&filters[sub_heading][Sub_Heading_Name][$eq]=${encodeURIComponent(
        subHeadingName
      )}`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

//   FRCSIT / Surgical / Lower Blepharoplasty - Banner
// FRCSIT / Surgical / Lower Blepharoplasty - Description
// frcsit-surgical-domains-consent-letters

